import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CambiarContrasenaComponent } from 'src/app/components/admin/usuarios/cambiar-contrasena/cambiar-contrasena.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  bsModalRef: BsModalRef;
  nombreSesion: string;
  estaLogueado: boolean;
  session: any;

  constructor(
    private auth: AuthService,
    private modalService: BsModalService,
    private router: Router
    ) { }

  ngOnInit() {
    this.auth.estaLogueado.subscribe(resultado => {
      this.session = this.auth.obtenerSesionUsuario();
      this.estaLogueado = resultado;
      this.nombreSesion = this.session ? this.session.nombre_session : "";
    });
  }

  abrirModal() {
    let options = {
      keyboard: true,
      ignoreBackdropClick: true,
    }

    this.bsModalRef = this.modalService.show(CambiarContrasenaComponent, options);
    this.bsModalRef.content.idUsuario = this.session.sessionId;

    this.modalService.onHidden.subscribe(() => {
      if(this.bsModalRef.content.cambioContrasena) {
        this.bsModalRef.content.cambioContrasena = false;
        this.salir();
      }
    });
  }

  salir() {
    this.auth.estaLogueado.next(false);
    this.auth.cerrarSesion();
    // Navigate to the login page with extras
    this.router.navigate(['/proveedores']);
  }

}
